import React from 'react'
import TerminoYCondiciones from '../components/templates/TerminoYCondicionesTemplate'

const TerminosYCondiciones = () => {
    return (
        <TerminoYCondiciones />
    )
}

export default TerminosYCondiciones